import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorServiceService {

  noConsolesInProd(env) {
    // Making sure all console do not out put in production.
    if (env) {
      console.assert = () => {
        return false;
      };
      console.count = () => {
        return false;
      };
      console.dir = () => {
        return false;
      };
      console.dirxml = () => {
        return false;
      };
      console.error = () => {
        return false;
      };
      console.group = () => {
        return false;
      };
      console.groupEnd = () => {
        return false;
      };
      console.info = () => {
        return false;
      };
      console.log = () => {
        return false;
      };
      console.table = () => {
        return false;
      };
      console.time = () => {
        return false;
      };
      console.timeEnd = () => {
        return false;
      };
      console.trace = () => {
        return false;
      };
      console.warn = () => {
        return false;
      };
    }
  }
}
